<mat-form-field class="pr-3">
  <mat-label>Tags</mat-label>
  <mat-chip-list #chipList class="py-2">
    <mat-chip
      *ngFor="let tag of selectedTags | keyvalue"
      [selectable]="true"
      [removable]="true"
      (removed)="removeTag(tag.value)"
    >
      {{ tag.value }}
      <mat-icon matChipRemove>cancel</mat-icon>
    </mat-chip>
    <input
      #tagsInput
      class="py-2"
      placeholder="New tag..."
      [matAutocomplete]="auto"
      [formControl]="addTagInputCtrl"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addTag($event)"
      (focus)="tagsInput.focused = true"
      (blur)="tagsInput.focused = false"
      [readonly]="readonly"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTag($event)">
    <ng-container *ngIf="tagsSearchResult$ | async as tagsSearchResult">
      <mat-option *ngFor="let tag of tagsSearchResult | keyvalue" [value]="tag.key">
        {{ tag.key }}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-hint *ngIf="tagsInput.focused" class="mt-2">
    Press <strong>TAB</strong> key after finishing typing to add a new tag
  </mat-hint>
</mat-form-field>
